
import { onMounted, ref } from "vue";
import { BritvicUmbracoAPIs } from "../../clients/search/src/britvicUmbracoAPIs";
import { IndexSettingsViewModel } from "../../clients/search/src/models";
export default {
  props: {
    endPoint: {
      type: String,
      required: true,
      default: ""
    },
    parentid: {
      type: Number,
      required: true,
      default: -1
    },
    culture: {
      type: String,
      required: false,
      default: ""
    }
  },
  setup(props, ctx) {
    const result = ref({} as IndexSettingsViewModel);
    const loading = ref(false);
    const error = ref(false);

    const fetchSettings = async (parentid = -1) => {
      loading.value = true;
      error.value = false;
      try {
        const SearchRepository = new BritvicUmbracoAPIs(props.endPoint);
        result.value = await SearchRepository.settings(parentid, {
          culture: props.culture
        });
        loading.value = false;
        ctx.emit("change", result.value);
      } catch (e) {
        console.log(e);
        error.value = true;
      }
    };

    onMounted(() => {
      fetchSettings(props.parentid);
    });
    return () =>
      ctx.slots.settings({
        settingsError: error.value,
        settings: result.value,
        settingsLoading: loading.value
      });
  }
};
